













import Vue from 'vue'
import { PortfolioMetadata } from '../types'

export default Vue.extend({
  name: 'PortfolioMetadata',

  props: {
    portfolio: Object,
  },

  methods: {
    hasData(metadata: PortfolioMetadata): boolean {
      return Object.values(metadata)
        .map(({ name }) => name)
        .some(val => val)
    },
    keysWithValues() {
      return Object.keys(this.portfolio.metadata)
        .filter(key => {
          const { name, url } = this.portfolio.metadata[key as keyof PortfolioMetadata]
          return name || url
        })
    },
    nameFor(key: keyof PortfolioMetadata): string {
      const { name } = this.portfolio.metadata[key]
      return name
    },
    urlFor(key: keyof PortfolioMetadata): string {
      const { url } = this.portfolio.metadata[key]
      return url
    },
  },
})
